<template>
  <div class="analysis-card">
    <div class="card-title">
      <div class="card-title-icon">
        <img class="icon" :src="meetingIcon" />
      </div>
      <span class="card-title-text">{{ attributes.type === 1 ? '通话提炼' : 'AI 跟进分析' }}</span>
    </div>

    <div v-if="attributes.type === 1" class="card-content">
      <div class="card-content-text">根据通话提炼内容，小助手已为你生成了一份跟进建议</div>
      <el-button style="width: 100%" @click="handleClickDetail">前往客户详情查看</el-button>
    </div>

    <div class="card-desc">
      <div class="card-desc-title">跟进智能评分</div>
      <div class="card-desc-desc">根据最近20 条跟进内容，小助手已为你智能评分</div>
    </div>

    <div v-if="scoreMetrics.length" class="card-main">
      <div class="card-main__title">
        <div class="card-main__title-icon" :style="getIconColorStyle(statusIcon.color)">
          {{ statusIcon.name }}
        </div>
        <div class="card-main__title-desc">完成情况</div>
        <div class="card-main__title-value">{{ hasFinish }}/{{ scoreMetrics.length }}</div>
      </div>
      <div class="card-main__box">
        <template v-for="(item, index) in scoreMetrics" :key="index">
          <div class="card-main__item">
            <i v-if="!item.match" class="icon-alert-fill t-iconfont"></i>
            <i v-else class="icon-checkbox-circle-fill t-iconfont"></i>
            <span>{{ item.name }}</span>
          </div>
        </template>
      </div>
    </div>

    <followupItem
      v-for="(desc, index) in scoreMetrics"
      :key="index"
      :attributes="attributes"
      :desc="desc"
      @getRemind="() => (desc.aiTodoSuggestTag = 1)"
      @refreshCard="refreshCard"
      @refreshList="refreshList"
    ></followupItem>
  </div>
</template>

<script setup>
// import xbb from '@xbb/xbb-utils'
import { ref, onMounted, computed } from 'vue'
import followupItem from './components/followup-item.vue'
import meetingIcon from '@/assets/meeting-analyse-icon.png'
// import xbb from 'xbb-sdk'

const props = defineProps({
  attributes: {
    type: Object
  }
})
const scoreMetrics = ref([])
const emits = defineEmits(['refreshList'])

const getData = async () => {
  if (props.attributes.matchResult) {
    try {
      scoreMetrics.value = JSON.parse(props.attributes.matchResult)
    } catch (err) {
      scoreMetrics.value = props.attributes.matchResult
    }
  }
  // const res = await getAnalysisData({})
  // cardData.value = res
  // scoreMetrics.value = res.dailyReportlist[0].scoreMetrics
  // finishScoreMetrics.value = res.dailyReportlist[0].finishScoreMetrics.map((item) => {
  //   if (!item.match && item.todoSuggest) {
  //     item.todoSuggest.hide = false
  //   }
  //   return {
  //     ...item
  //   }
  // })
}

const handleClickDetail = () => {
  // const { appId, dataId, saasMark, businessType, subBusinessType } = props.attributes.detailInfo
  // xbb.useComponent({
  //   action: 'openDetailPage',
  //   data: {
  //     appId: appId,
  //     dataId: dataId,
  //     saasMark: saasMark,
  //     businessType: businessType,
  //     subBusinessType: subBusinessType
  //   }
  // })
}

const getIconColorStyle = (color) => {
  if (!color) return ''
  // 将16进制颜色值转换为透明度为10%的颜色值
  const transparentColor = (hexColor) => {
    const red = parseInt(hexColor.slice(1, 3), 16)
    const green = parseInt(hexColor.slice(3, 5), 16)
    const blue = parseInt(hexColor.slice(5, 7), 16)
    return `rgba(${red}, ${green}, ${blue}, 0.1)`
  }
  const backgroundColor = transparentColor(color)
  return `color: ${color};background-color: ${backgroundColor}`
}

const hasFinish = computed(() => {
  return scoreMetrics.value.reduce((acc, item) => {
    return item.match ? acc + 1 : acc
  }, 0)
})

const statusIcon = computed(() => {
  const iconMap = {
    1: {
      name: '低',
      color: '#F54E4E'
    },
    2: {
      name: '中',
      color: '#3352FF'
    },
    3: {
      name: '高',
      color: '#00C241'
    }
  }
  return iconMap[props.attributes.scoreDegree || 1]
})

const refreshList = () => {
  emits('refreshList')
}

function refreshCard(sseData) {
  scoreMetrics.value = sseData?.chatInfo?.matchResult
}

onMounted(() => {
  getData()
})
</script>

<style lang="less" scoped>
.analysis-card {
  width: 100%;
  position: relative;
  background-color: #ffffff;
  box-sizing: border-box;
  font-family: PingFang SC;
  .card-title {
    display: flex;
    height: 32px;

    box-sizing: border-box;
    border-bottom: 1px solid #f2f3f5;
    .card-title-icon {
      width: 20px;
      height: 20px;
      border-radius: 4px;
      background: #e8f7ff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 8px;
      img {
        height: 100%;
        width: 100%;
      }
      i {
        font-size: 14px;
        color: #248df5;
      }
    }
    .card-title-text {
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: #323233;
    }
  }
  .card-content {
    margin-top: 16px;
    .card-content-text {
      line-height: 20px;
      font-size: 14px;
      color: #323233;
      margin-bottom: 12px;
    }
  }

  .card-desc {
    margin-top: 16px;
    .card-desc-title {
      line-height: 22px;
      font-size: 16px;
      font-weight: 600;
      color: #323233;
      margin-bottom: 4px;
    }
    .card-desc-desc {
      line-height: 20px;
      font-size: 14px;
      color: #969799;
    }
  }

  .card-main {
    margin-top: 12px;
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    padding: 8px 12px;
    border-radius: 8px;
    box-sizing: border-box;
    border: 1px solid #f2f3f5;
    .card-main__title {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .card-main__title-icon {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        background: #ece8ff;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 8px;
        font-size: 12px;
      }
      .card-main__title-desc {
        font-size: 14px;
        font-weight: 600;
        color: #646566;
        margin-right: 8px;
      }
      .card-main__title-value {
        font-weight: 600;
        font-size: 18px;
        color: #323233;
      }
    }
    .card-main__box {
      display: flex;
      flex-wrap: wrap;
      position: relative;
      .card-main__item {
        padding: 6px 8px;
        display: flex;
        align-items: center;
        margin-right: 8px;
        .icon-checkbox-circle-fill {
          color: #00c241;
          margin-right: 4px;
        }
        .icon-alert-fill {
          color: #ffb521;
          margin-right: 4px;
        }
      }
    }
  }
}
</style>
